import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { TabNames, offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";

@Component({
  selector: "app-tab-channel-chat-with-admin-component",
  templateUrl: "./tab-channel-chat-with-admin-component.component.html",
  styleUrls: ["./tab-channel-chat-with-admin-component.component.scss"],
})
export class TabChannelChatWithAdminComponentComponent implements OnInit, OnDestroy {
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService
  ) {}

  @Input() tab_id: string;
  tab: Tab;
  mode: string;

  // default values
  imageLg: string;
  imageSm: string;
  image: string;
  icon: string;
  icon_ios: string;
  title: string;
  roundedBottom = true;
  offCanvasSubscription: any;
  enableChatWithAdmin = false;
  textColor = "#ffffff";
  stickyBgColor = "#ff2121";
  offcanvasColors = offcanvasColors;
  newTab = false;
  floating_button = {
    bg_color: null,
    size: 'm',
    type: 'talk_admin'
  };
  iconSize = {
      l: 'Large'
    ,
      m: 'Medium'
    ,
      s: 'Small'
  };
  selectedIconSize = 'm';
  selectedIconBg;
  colors;
  channel_default;
  ngOnInit() {
      const ChannelDefault = this.indexDBService.getItem("item", "channel_default");
  ChannelDefault.onsuccess = (event) => {
    this.channel_default = ChannelDefault.result;
          if (this.channel_default && this.channel_default.floating_button && this.channel_default.floating_button.length > 0) {
            this.enableChatWithAdmin = true
            this.floating_button = this.channel_default.floating_button[0];
            this.selectedIconSize = this.channel_default.floating_button[0].size;
            this.selectedIconBg = this.channel_default.floating_button[0].bg_color;
            if(   this.selectedIconBg  === null){
            const itemColor = this.indexDBService.getItem("item", "color");
            itemColor.onsuccess = (event) => {
              this.colors = itemColor.result;
              this.selectedIconBg = this.colors.primary;
            }
          }
          }
        }

  }



  colorIconChange(val) {
    const ChannelDefault = this.indexDBService.getItem("item", "channel_default");
    ChannelDefault.onsuccess = (event) => {
      this.channel_default = ChannelDefault.result;
    const floating_button_list = [];
    const floating_button = this.floating_button;
    floating_button.bg_color = val;
    floating_button_list.push(floating_button)
    this.channel_default.floating_button = floating_button_list;
    const inputData = { ...this.channel_default }

    inputData.id = 'channel_default'
    this.indexDBService.updateItem("item", inputData);
    this.channel_default = inputData;
    }
  }

  changeIconSize(val){
    const ChannelDefault = this.indexDBService.getItem("item", "channel_default");
    ChannelDefault.onsuccess = (event) => {
      this.channel_default = ChannelDefault.result;
    const floating_button_list = [];
    const floating_button = this.floating_button;
    floating_button.size = val;
    floating_button_list.push(floating_button)
    this.channel_default.floating_button = floating_button_list;
    const inputData = { ...this.channel_default }

    inputData.id = 'channel_default'
    this.indexDBService.updateItem("item", inputData);
    this.channel_default = inputData;
    }
  }
  toggleAdminTalk(val) {
    const ChannelDefault = this.indexDBService.getItem("item", "channel_default");
    ChannelDefault.onsuccess = (event) => {
      this.channel_default = ChannelDefault.result;
    const floating_button_list = [];
    if(val){
      floating_button_list.push(this.floating_button )
    }
    this.enableChatWithAdmin = val;
    this.channel_default.floating_button = floating_button_list;
    const inputData = { ...this.channel_default }

    inputData.id = 'channel_default'
    this.indexDBService.updateItem("item", inputData);
    this.channel_default = inputData;
  }
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
  }
}




